var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../utils/mobx/decorators/customComputed';
import { flatten, uniq } from '../../../utils/helper/lodash_replacements';
export class ContextSwitches {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get context() {
        return this.parent;
    }
    get detectedSwitches() {
        return flatten(this.context.actor.exportingTree.allTraitsOfExportingActors
            .filter(trait => !!trait.condition)
            .map(trait => trait.condition.recursiveConditions)).filter(condition => !!condition && condition.conditionKey === 'switched');
    }
    get detectedSwitchNames() {
        return uniq(this.detectedSwitches.map(condition => condition.local.valueOf.switchName));
    }
}
__decorate([
    cachedSet
], ContextSwitches.prototype, "detectedSwitches", null);
